import http from "../http-common";

class CalendarService {

    // Calendar
    getCalendars = () => http.get('/calendars');

    getCalendarById = (calendar_id) => http.get(`/calendars/${calendar_id}`);

    createCalendar = (data) => http.post('/calendars', data);

    updateCalendar = (calendar_id, data) => http.put(`/calendars/${calendar_id}`, data);

    acceptCalendarInvite = (calendar_id) => http.put(`/calendars/${calendar_id}/invite`);

    deleteCalendar = (calendar_id) => http.delete(`/calendars/${calendar_id}`);

    // Calendar Members
    addCalendarMember = (calendar_id, data) => http.post(`/calendars/${calendar_id}/members`, data);

    updateCalendarMemberRole = (calendar_id, member_id, data) => http.put(`/calendars/${calendar_id}/members/${member_id}`, data);

    removeCalendarMember = (calendar_id, member_id) => http.delete(`/calendars/${calendar_id}/members/${member_id}`);

    // Events
    addEvent = (calendar_id, data) => http.post(`/calendars/${calendar_id}/events`, data);

    updateEvent = (calendar_id, event_id, data) => http.put(`/calendars/${calendar_id}/events/${event_id}`, data);

    updateEventTime = (calendar_id, event_id, data) => http.put(`/calendars/${calendar_id}/events/${event_id}/time`, data);

    handleEventparticipants = (calendar_id, event_id, data) => http.put(`/calendars/${calendar_id}/events/${event_id}/participants`, data);

    deleteEvent = (calendar_id, event_id) => http.delete(`/calendars/${calendar_id}/events/${event_id}`);

    getEvents = (calendar_id, date) => http.get(`/calendars/${calendar_id}/events?date=${date}`);

    getEventById = (calendar_id, event_id) => http.get(`/calendars/${calendar_id}/events/${event_id}`);
}
export default new CalendarService();
